<template>
  <div class="grid p-fluid animate__animated animate__fadeIn">
    <div class="col-12">
      <div class="card card-w-title">
        <h5 class="mb-0">رزرو ها</h5>
        <Divider type="dashed" />
        <div class="card grid shadow-2 mt-3 p-0">
          <div class="field col-12 md:col-3">
            <InputNumber v-model="UserId" dir="rtl" placeholder="آی دی کاربر" mode="decimal" :useGrouping="false" />
          </div>
          <div class="field col-12 md:col-3">
            <InputNumber v-model="PriceMin" dir="rtl" placeholder="حداقل خرید" mode="decimal" />
          </div>
          <div class="field col-12 md:col-3">
            <InputNumber v-model="PriceMax" dir="rtl" placeholder="حداکثر خرید" mode="decimal" />
          </div>
          <div v-if="!!places.length" class="col-12 md:col-3">
            <MultiSelect v-model="PlacesId" :options="places" optionLabel="name" optionValue="id" :showToggleAll="false" placeholder="انتخاب اقامتگاه" />
          </div>
          <div class="col-12 md:col-3">
            <Dropdown v-model="StatusPayment" :options="paymentsStatus" optionLabel="type" optionValue="value" placeholder="وضعیت پرداخت" />
          </div>
          <div class="col-12 md:col-3">
            <Dropdown v-model="StatusAccept" :options="reserveTypes" optionLabel="type" optionValue="value" placeholder="وضعیت تایید" />
          </div>
          <div class="field col-12 md:col-3">
            <span class="p-input-icon-left">
              <i v-if="!FromDate" style="font-size: 1.5rem" class="pi pi-calendar" />
              <i
                v-else
                @click="
                  FromDate = null;
                  getReserveList(pageIndex);
                "
                style="font-size: 1.5rem"
                class="pi pi-calendar-times cursor-pointer"
              />
              <InputText dir="rtl" v-model="FromDateInput" type="text" id="fromCalendarInputId" placeholder="از تاریخ" />
            </span>
            <custom-date-picker auto-submit v-model="FromDate" :max="currentDate" format="YYYY-MM-DD" display-format="jYYYY/jMM/jDD" custom-input="#fromCalendarInputId" />
          </div>
          <div class="field col-12 md:col-3">
            <span class="p-input-icon-left">
              <i v-if="!ToDate" style="font-size: 1.5rem" class="pi pi-calendar" />
              <i
                v-else
                @click="
                  ToDate = null;
                  getReserveList(pageIndex);
                "
                style="font-size: 1.5rem"
                class="pi pi-calendar-times cursor-pointer"
              />
              <InputText dir="rtl" v-model="ToDateInput" type="text" id="toCalendarInputId" placeholder="تا تاریخ" />
            </span>
            <custom-date-picker auto-submit v-model="ToDate" :max="currentDate" format="YYYY-MM-DD" display-format="jYYYY/jMM/jDD" custom-input="#toCalendarInputId" />
          </div>
          <div class="field col-12 md:col-2">
            <Button @click="getReserveList(pageIndex)">اعمال فیلتر</Button>
          </div>
        </div>
        <!-- Table Section Begin -->
        <div v-if="!!reserves.length">
          <DataTable
            :loading="loading.getData"
            ref="dt"
            :value="reserves"
            dataKey="id"
            stripedRows
            class="overflow-hidden border-round-2xl shadow-1 mt-5 animate__animated animate__fadeIn"
            responsiveLayout="scroll"
          >
            <template #loading>
              <Loading />
            </template>
            <Column field="title" headerStyle="width:14%; min-width:10rem;">
              <template #header>
                <small>نام اقامتگاه</small>
              </template>
              <template #body="slotProps">
                <small>{{ slotProps.data.placeTitle }}</small>
              </template>
            </Column>
            <Column headerStyle="width:14%; min-width:10rem;">
              <template #header>
                <small>تاریخ ورود</small>
              </template>
              <template #body="slotProps">
                <small>{{ new Date(slotProps.data.entryDate).toLocaleDateString("fa-IR") }}</small>
              </template>
            </Column>
            <Column headerStyle="width:14%; min-width:10rem;">
              <template #header>
                <small>تاریخ خروج</small>
              </template>
              <template #body="slotProps">
                <small>{{ new Date(slotProps.data.exitDate).toLocaleDateString("fa-IR") }}</small>
              </template>
            </Column>
            <Column headerStyle="width:14%; min-width:10rem;">
              <template #header>
                <small>وضعیت پرداخت</small>
              </template>
              <template #body="slotProps">
                <small>{{ paymentsStatus.find((item) => item.value === slotProps.data.statusPayment).type }}</small>
              </template>
            </Column>
            <Column headerStyle="width:14%; min-width:10rem;">
              <template #header>
                <small>وضعیت تایید</small>
              </template>
              <template #body="slotProps">
                <small>{{ reserveTypes.find((item) => item.value === slotProps.data.statusAccept).type }}</small>
              </template>
            </Column>
            <Column field="title" headerStyle="width:14%; min-width:10rem;">
              <template #header>
                <small>مبلغ پیش پرداخت(تومان)</small>
              </template>
              <template #body="slotProps">
                <small>{{ slotProps.data.prepaidPrice.toLocaleString("fa-IR") }}</small>
              </template>
            </Column>
            <Column field="title" headerStyle="width:14%; min-width:10rem;">
              <template #header>
                <small>مبلغ کل(تومان)</small>
              </template>
              <template #body="slotProps">
                <small>{{ slotProps.data.totalPrice.toLocaleString("fa-IR") }}</small>
              </template>
            </Column>
            <Column headerStyle="min-width:10rem;">
              <template #header>
                <small>عملیات</small>
              </template>
              <template #body="slotProps">
                <Button @click="showDetails(slotProps.data)" icon="pi pi-external-link" v-tooltip.top="'مشاهده بیشتر'" class="p-button-rounded p-button-secondary ml-2" />
              </template>
            </Column>
          </DataTable>
          <Paginator :rows="pageSize" :totalRecords="totalCount" @page="changePaging($event)"></Paginator>
        </div>
        <div v-else class="w-full text-center my-3">
          <InlineMessage>موردی وجود ندارد</InlineMessage>
        </div>
        <!-- Table Section End -->
        <!--*************** Show detail Dialog Section Begin ***************-->
        <Dialog @hide="closeDialog()" v-model:visible="openDetailDialog" :style="{ width: '800px' }" header="اطلاعات بیشتر" :modal="true" class="p-fluid">
          <Divider type="dashed" align="center">
            <div class="inline-flex align-items-center text-primary">
              <b>اطلاعات کلی</b>
            </div>
          </Divider>
          <div class="flex justify-content-between">
            <div>
              <strong>نام اقامتگاه: </strong>
              <span class="mx-1">{{ selectedReserve.placeTitle }}</span>
            </div>
            <div>
              <strong>تاریخ ورود: </strong>
              <span class="mx-1">{{ new Date(selectedReserve.entryDate).toLocaleDateString("fa-IR") }}</span>
            </div>
            <div>
              <strong>تاریخ خروج: </strong>
              <span class="mx-1">{{ new Date(selectedReserve.exitDate).toLocaleDateString("fa-IR") }}</span>
            </div>
            <div>
              <strong>تعداد نفرات: </strong>
              <span class="mx-1">{{ selectedReserve.personCount }}</span>
            </div>
          </div>
          <Divider type="dashed" align="center">
            <div class="inline-flex align-items-center text-primary">
              <b>جزئیات رزرو</b>
            </div>
          </Divider>
          <div v-for="(reserve, index) in selectedReserve.reservedServices" :key="`reserve-${index}`" class="flex flex-column">
            <div class="flex justify-content-between">
              <div>
                <strong>⁜ نام اتاق: </strong>
                <span class="mx-1">{{ reserve.name }}</span>
              </div>
              <div class="mx-2">
                <strong>مبلغ کل رزرو اتاق:</strong>
                <span class="mx-1">{{ reserve.totalServicePrice.toLocaleString("fa-IR") }} تومان</span>
              </div>
            </div>
            <div v-for="(supervisor, _index) in reserve.supervisorsInfo" :key="`supervisor-${_index}`" class="flex flex-column mt-3">
              <h6 class="mb-0">– اطلاعات سرپرست {{ reserve.supervisorsInfo.length === 1 ? "" : `(اتاق ${_index})` }}:</h6>
              <div class="flex justify-content-between align-items-center mt-2">
                <div>
                  <span>نام سرپرست :</span>
                  <small>{{ supervisor.fullName }}</small>
                </div>
                <div>
                  <span>شماره ملی :</span>
                  <small>{{ supervisor.nationalCode }}</small>
                </div>
                <div>
                  <span>شماره همراه: </span>
                  <small>{{ supervisor.phoneNumber }}</small>
                </div>
              </div>
            </div>
            <Divider v-if="selectedReserve.reservedServices.length - 1 !== index" />
          </div>
        </Dialog>
        <!--*************** Show detail Dialog Section Ended ***************-->
      </div>
    </div>
  </div>
</template>

<script>
import { handleQuery } from "@/utils/index";
export default {
  name: "reserves",
  data() {
    return {
      loading: {
        getData: false,
      },
      openDetailDialog: false,
      pageIndex: 1,
      pageSize: 10,
      totalCount: 1,
      pageCount: 1,
      paymentsStatus: [
        { type: "همه", value: null },
        { type: "پرداخت نشده", value: 0 },
        { type: "ناموفق", value: 1 },
        { type: "موفق", value: 2 },
      ],
      reserves: [],
      currentDate: `${new Date(Date.now()).getFullYear()}-${new Date(Date.now()).getMonth() + 1}-${new Date(Date.now()).getDate() + 1}`,
      reserveTypes: [
        { type: "همه", value: null },
        { type: "معلق", value: 0 },
        { type: "تایید شده", value: 1 },
        { type: "لغو شده", value: 2 },
        { type: "رد شده", value: 3 },
      ],
      FromDateInput: "",
      ToDateInput: "",
      IsSuccess: null,
      FromDate: "",
      ToDate: "",
      ReserveId: null,
      UserId: null,
      PlacesId: null,
      places: [],
      totalItemsCount: [],
      StatusPayment: null,
      PriceMin: null,
      PriceMax: null,
      StatusAccept: null,
      // ServicesId
      selectedReserve: null,
    };
  },
  methods: {
    //******* Api methods begin *******//
    async getReserveList(page = 1) {
      this.loading.getData = true;
      let params = {
        StatusPayment: this.StatusPayment,
        PageIndex: page,
        PageSize: this.pageSize,
        StatusAccept: this.StatusAccept,
        from: this.FromDate,
        to: this.ToDate,
        UserId: this.UserId,
        PlacesId: !!this.PlacesId?.length ? this.PlacesId : null,
        PriceMin: this.PriceMin,
        PriceMax: this.PriceMax,
        // ServicesId
      };
      const { status, data } = await this.axios.get(`reserve`, { params: params, paramsSerializer: handleQuery });
      if (status === 200) {
        this.pageSize = Number(data.pageSize);
        this.pageIndex = data.pageIndex;
        this.totalCount = Number(data.totalCount);
        this.pageCount = +data.pageCount;
        this.reserves = [...data.data];
        setTimeout(() => {
          this.loading.getData = false;
        }, 500);
      }
    },
    async getListPlaces(page = 1) {
      const { status, data } = await this.axios({ method: "get", url: `Place/GetAll?TitleQuery=&PageIndex=${page}&PageSize=${this.pageSize}` });
      this.totalItemsCount = data.pageCount;
      this.places.push.apply(this.places, data.data);
      setTimeout(() => {
        this.loading["getData"] = false;
      }, 1000);
    },
    //******* Api methods end *******//
    changePaging(e) {
      this.getReserveList(++e.page);
    },
    showDetails(data) {
      this.selectedReserve = { ...data };
      this.openDetailDialog = true;
    },
    closeDialog() {
      this.selectedReserve = null;
      this.openDetailDialog = false;
    },
  },
  mounted() {
    this.getReserveList();
    this.getListPlaces();
  },
};
</script>
